module.exports = vendor_806189933e3be0f1ec16;


//////////////////
// WEBPACK FOOTER
// external "vendor_806189933e3be0f1ec16"
// module id = 2
// module chunks = 10